import WaitDialog from "./wait-dialog";
export default WaitDialog;
